/**
 * Formats a date string into a readable format of "day de month de year" in Spanish.
 *
 * @param {string} dateString - The date string to format, in a format accepted by the JavaScript Date constructor.
 * @return {string} The formatted date string in the format "day de month de year".
 */
export function formatDate(dateString) {
    const months = [
        'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
        'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];
    const date = new Date(dateString);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} de ${month} de ${year}`;
}
